import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const spur = defineConnector({
  identifier: "spur",
  name: "Spur",
  tagLine: "VPN and proxy detection",
  logo,
  protocol: "http",
  tags: ["security"],
  defaultUrlPattern: () => "https://api\\.spur\\.us/.*",
  auth: (app) => headerAuth([{ name: "Token", value: app.secret.apiKey }]),
  steps: [
    {
      title: "Get an API token",
      items: [
        {
          kind: "markdown",
          content:
            "Log in to your [Spur](https://spur.us/) account. Click **Account** in the upper right corner, then scroll down to **Tokens** and click **Reset API Token** to generate a new token.",
        },
      ],
    },
    {
      title: "Copy and paste your API token into the field below",
      items: [
        {
          kind: "input",
          label: "Spur API token",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://api.spur.us/status",
  },
});
